webpackJsonp([30,35],{

/***/ 14:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'switch',
	  props: {
	    showTag: {
	      type: Boolean,
	      default: false
	    },
	    tag: {
	      type: Array,
	      default: function _default() {
	        return ['开', '关'];
	      }
	    },
	    value: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    _handleClick: function _handleClick() {
	      this.stateSelf = !this.stateSelf;
	      this.$emit('on-click', this.stateSelf);
	      this.$emit('input', this.stateSelf);
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    }
	  },
	  computed: {
	    cssState: function cssState() {
	      var state = '';
	      if (this.showTag && !this.stateSelf) {
	        state = 'switch-tag-off';
	      } else if (!this.showTag && !this.stateSelf) {
	        state = 'switch-off';
	      } else {
	        state = 'switch-on';
	      }
	      return state;
	    }
	  },
	  watch: {
	    value: function value(newval) {
	      this.stateSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      stateSelf: this.value
	    };
	  }
	};

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(14),
	  /* template */
	  __webpack_require__(18),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "switch",
	    class: [
	      _vm.showTag ? 'switch-tag' : '',
	      _vm.cssState
	    ],
	    on: {
	      "click": _vm._handleClick
	    }
	  }, [(_vm.showTag) ? _c('span', {
	    staticClass: "on"
	  }, [_vm._v(_vm._s(_vm.tag[0]))]) : _vm._e(), _vm._v(" "), (_vm.showTag) ? _c('span', {
	    staticClass: "off"
	  }, [_vm._v(_vm._s(_vm.tag[1]))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(109),
	  /* template */
	  __webpack_require__(222),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boSwitch = __webpack_require__(16);
	
	var _boSwitch2 = _interopRequireDefault(_boSwitch);
	
	var _menuVertical = __webpack_require__(13);
	
	var _menuVertical2 = _interopRequireDefault(_menuVertical);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'switchdemo',
	  components: {
	    BoSwitch: _boSwitch2.default,
	    menuVertical: _menuVertical2.default
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.state = true;
	    }, 1000);
	  },
	  data: function data() {
	    return {
	      state: false
	    };
	  }
	};

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ul', {
	    staticClass: "list list-box p0002"
	  }, [_c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("默认(打开)")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-switch')], 1)])], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("默认(关闭)")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-switch', {
	    attrs: {
	      "value": false
	    }
	  })], 1)])], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("带文字")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-switch', {
	    attrs: {
	      "value": false,
	      "show-tag": true
	    }
	  })], 1)])], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("自定义文字")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-switch', {
	    attrs: {
	      "show-tag": true,
	      "tag": ['ON', 'OFF']
	    }
	  })], 1)])], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("异步修改状态")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-switch', {
	    model: {
	      value: (_vm.state),
	      callback: function($$v) {
	        _vm.state = $$v
	      },
	      expression: "state"
	    }
	  })], 1)])], 1)])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/30.32f2658b676eaf5d958d.js